import dayjs from "dayjs"

import { LOST_STATUSES } from "../../AllPage/constants/statusMeta"

// Activity log for a dispute (rendered in the Logs modal). Derived from the dispute's
// timestamps + status so it reads as a realistic event history, mirroring the Alerts
// detail's Logs tab (Status / Date rows, newest first). Timestamps are UTC display.
export const buildDisputeLogs = (dispute, t) => {
  if (!dispute) return []
  const created = dispute.dispute_created_at ? dayjs(dispute.dispute_created_at) : null
  const updated = dispute.updated_at ? dayjs(dispute.updated_at) : created || dayjs()
  const status = dispute.status
  const events = []
  if (dispute.transaction_date)
    events.push({
      label: t("Transaction created"),
      at: dayjs(dispute.transaction_date),
      type: "created"
    })
  if (created) events.push({ label: t("Dispute was received"), at: created, type: "received" })
  // Evidence produced for anything past the initial needs-response state.
  if (status !== "needs_response" && created) {
    events.push({
      label: t("Evidence was generated"),
      at: created.add(6, "hour"),
      type: "generated"
    })
  }
  if (dispute.assigned_to?.name && created) {
    events.push({
      label: t("Assigned to _name_", { name: dispute.assigned_to.name }),
      at: created.add(9, "hour"),
      type: "assigned"
    })
  }
  // lost_undefended is deliberately absent: nothing was ever submitted on those.
  if (["pending_decision", "won", "lost_defended"].includes(status)) {
    events.push({
      label: t("Evidence was submitted to the issuer"),
      at: updated.subtract(1, "day"),
      type: "submitted"
    })
  }
  if (status === "awaiting_review")
    events.push({ label: t("Evidence is ready for your review"), at: updated, type: "review" })
  if (status === "pending_decision")
    events.push({ label: t("Awaiting the issuer decision"), at: updated, type: "pending" })
  if (status === "won") events.push({ label: t("Dispute was won"), at: updated, type: "won" })
  if (LOST_STATUSES.includes(status))
    events.push({ label: t("Dispute was lost"), at: updated, type: "lost" })
  if (status === "escalated")
    events.push({
      label: t("Inquiry escalated towards a formal dispute"),
      at: updated,
      type: "escalated"
    })
  return events
    .sort((a, b) => b.at.valueOf() - a.at.valueOf())
    .map((e, i) => ({
      key: `${i}-${e.label}`,
      label: e.label,
      date: `${e.at.format("DD MMM YYYY hh:mm A")} (UTC)`,
      type: e.type
    }))
}
